import { mockCurrentUserSumoQuery } from '@sbu/views.nav/build/mocks';

export const handlers = [
  mockCurrentUserSumoQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        currentUserSumo: {
          id: '114109369',
          name: 'knamburi@sumologic.com',
          firstName: 'Krishna',
          lastName: 'Namburi',
          organization: 'cse-stag-sandbox',
          organizationId: 111992367,
          switchableOrgs: [],
          __typename: 'CurrentUserSumo',
        },
      })
    );
  }),
];
